"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_VERSION = exports.PKG_VERSION = exports.PKG_NAME = void 0;
exports.PKG_NAME = "@hpcc-js/dgrid-shim";
exports.PKG_VERSION = "2.26.0";
exports.BUILD_VERSION = "2.107.1";
//# sourceMappingURL=__package__.js.map